import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  CircularProgress,
  Alert,
  Box,
  Divider,
} from "@mui/material";

const subjectIcons = {
  // Math
  math: "➗",
  maths: "➗",

  // Chemistry
  chemistry: "🧪",
  chem: "🧪",

  // English
  english: "📚",
  eng: "📚",

  // Environment
  environment: "🌱",
  enviro: "🌱",
  env: "🌱",

  // Hindi
  hindi: "📖",

  // Test/Exam
  test: "📝",
  exam: "📝",

  // Science
  science: "🔬",

  // Physics
  physics: "⚛️",

  // Biology
  biology: "🦠",
  bio: "🦠",

  // History
  history: "🏛️",

  // Geography
  geography: "🌍",
  geo: "🌍",

  // Computer
  computer: "💻",
  comp: "💻",
  cs: "💻",

  // Add more mappings as needed
};



const AssignmentList = () => {
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAssignments = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = process.env.REACT_APP_BASE_URL;

      const response = await fetch(`${apiUrl}/Student/GetStudentAssignment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          studentID: sessionStorage.getItem("employeeId"),
          classId: sessionStorage.getItem("classId"),
          sectionId: sessionStorage.getItem("sectionId"),
        }),
      });

      if (!response.ok) {
        throw new Error(`Error fetching assignments: ${response.status}`);
      }

      const data = await response.json();

      // Handle both direct array and nested objData
      if (Array.isArray(data)) {
        setAssignments(data);
      } else if (data.objData && Array.isArray(data.objData)) {
        setAssignments(data.objData);
      } else {
        setAssignments([]);
      }

      setLoading(false);
    } catch (error) {
      setError("Failed to load assignments. Please try again later.");
      setLoading(false);
      console.error("Fetch assignments error:", error);
    }
  };

  useEffect(() => {
    fetchAssignments();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" style={{ margin: "20px" }}>
        {error}
      </Alert>
    );
  }

  const getSubjectIcon = (subjectName) => {
  const lowerSubject = subjectName.toLowerCase();
  for (const [key, icon] of Object.entries(subjectIcons)) {
    if (lowerSubject.includes(key)) {
      return icon;
    }
  }
  return "📂"; // Default icon for unknown subjects
};

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold", color: "#333" }}>
        Your Assignments
      </Typography>
      <Divider sx={{ mb: 3 }} />

      {assignments.length === 0 ? (
        <Alert severity="info" sx={{ mt: 2 }}>
          No assignments available at the moment. Check back later!
        </Alert>
      ) : (
        <Grid container spacing={3}>
          {assignments.map((assignment) => (
            <Grid item xs={12} sm={6} md={4} key={assignment.subjectId}>
              <Link
                to={`/studentassignmentDetails/${assignment.subjectId}`}
                style={{ textDecoration: "none" }}
              >
                <Card
                  sx={{
                    height: "100%",
                    transition: "transform 0.2s, box-shadow 0.2s",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0 8px 16px rgba(0, 0, 0, 0.1)",
                    },
                  }}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      textAlign: "center",
                      p: 3,
                    }}
                  >
                    <Box sx={{ fontSize: "48px", mb: 2, color: "#4596a4" }}>
                      {getSubjectIcon(assignment.subjectName)}
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: "bold", color: "#333" }}>
                      {assignment.subjectName} {/* Display original name */}
                    </Typography>
                  </CardContent>
                </Card>
              </Link>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default AssignmentList;
